/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Status_RetryingInputs */

const en_import_status_retrying = /** @type {(inputs: Import_Status_RetryingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trying again shortly`)
};

const de_import_status_retrying = /** @type {(inputs: Import_Status_RetryingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Versuch in Kürze`)
};

/**
* | output |
* | --- |
* | "Trying again shortly" |
*
* @param {Import_Status_RetryingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_status_retrying = /** @type {((inputs?: Import_Status_RetryingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Status_RetryingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_status_retrying(inputs)
	return en_import_status_retrying(inputs)
});